import React, { useRef, useEffect, useState } from 'react';
import { VariableSizeList as VirtualList } from 'react-window';
import { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';
import { Button } from 'antd';
import ListItem from './listItem';
import { getContactItemKey, isOrg } from '@web-common/components/util/contact';
import styles from './index.module.scss';
import useContactItemEffect from '@web-common/components/UI/SiriusContact/useContactItemEffect';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { apiHolder as api, apis, getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const ContactList = props => {
    const { useContactId, showPosition, showAvatar = true, showCheckbox = false, showDelete = true, showFooter = true, selectList: defaultSelectList = [], onDelete, onCancel, onSure, needScrollBottom = true, canSure = true, firstPositionNotDelEmail, } = props;
    const [selectMap, setSelectMap] = useState(new Map());
    const listRef = useRef(null);
    const getSelectList = () => {
        return [...selectMap.values()];
    };
    const handleListDelete = (data) => {
        selectMap.delete(getContactItemKey(data, useContactId));
        setSelectMap(selectMap);
        onDelete && onDelete(getSelectList(), [data]);
    };
    const handleListCancel = () => {
        onCancel && onCancel(getSelectList());
    };
    useContactItemEffect(defaultSelectList, () => {
        var _a;
        const itemMap = new Map();
        defaultSelectList.forEach(item => {
            const key = isOrg(item) ? item.id : getContactItemKey(item, useContactId);
            itemMap.set(key, item);
        });
        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndex(0);
        setSelectMap(itemMap);
    }, useContactId);
    useEffect(() => {
        needScrollBottom &&
            setTimeout(() => {
                var _a;
                (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(selectMap.size);
            }, 500);
    }, [needScrollBottom, listRef]);
    const selectList = getSelectList();
    const [contact2SubAccountMap, setContact2SubAccountMap] = useState({});
    const [loadingMap, setloadingMap] = useState({});
    const [showSubAccounMap, setShowSubAccountMap] = useState({});
    const [selectSubAccountMap, setSelectSubAccountMap] = useState({});
    const handleListSure = () => {
        const selectList = getSelectList();
        const toList = selectList.map(item => {
            var _a, _b;
            const res = {
                account: item.email,
            };
            if ((_a = selectSubAccountMap[item.id]) === null || _a === void 0 ? void 0 : _a.innerEmail) {
                res['subAccount'] = (_b = selectSubAccountMap[item.id]) === null || _b === void 0 ? void 0 : _b.innerEmail;
            }
            return res;
        });
        onSure && onSure(toList);
    };
    const handleChangeSA = (id, emial) => {
        if (!contact2SubAccountMap[id]) {
            setloadingMap(data => {
                return Object.assign(Object.assign({}, data), { [id]: true });
            });
            mailApi
                .getOthersSubMailboxV2(emial)
                .then(res => {
                const { account, subEmails } = res;
                setloadingMap(data => {
                    return Object.assign(Object.assign({}, data), { [id]: false });
                });
                setContact2SubAccountMap(data => {
                    return Object.assign(Object.assign({}, data), { [id]: subEmails });
                });
                if (subEmails.length > 1) {
                    setShowSubAccountMap(data => {
                        return Object.assign(Object.assign({}, data), { [id]: true });
                    });
                }
            })
                .catch(err => {
                message.open({ type: 'error', content: '获取子账号失败' });
                console.error('handleChangeSA 获取子账号失败', err);
                setloadingMap(data => {
                    return Object.assign(Object.assign({}, data), { [id]: false });
                });
            });
        }
        else {
            setShowSubAccountMap(data => {
                return Object.assign(Object.assign({}, data), { [id]: true });
            });
        }
    };
    const renderList = () => {
        if (selectList.length) {
            return (React.createElement(AutoSizer, null, ({ width, height }) => (React.createElement(VirtualList, { ref: listRef, itemSize: index => {
                    var _a;
                    const _item = selectList[index];
                    if (isOrg(_item)) {
                        return 52;
                    }
                    else {
                        const item = _item;
                        return showPosition && ((_a = item === null || item === void 0 ? void 0 : item.position) === null || _a === void 0 ? void 0 : _a.length) ? 72 : 52;
                    }
                }, itemCount: selectMap.size, height: height, width: width, className: styles.vScrollList }, ({ index, style }) => {
                var _a;
                const item = selectList[index];
                const { id } = item;
                const isOrgItem = isOrg(item);
                const key = isOrgItem ? item.id : getContactItemKey(item, useContactId);
                const _showDelete = showDelete && (isOrgItem || firstPositionNotDelEmail !== item.email);
                const subAccountList = contact2SubAccountMap[id];
                return (React.createElement("div", { className: styles.listItem, key: key, style: Object.assign({}, style) },
                    React.createElement(ListItem, { testId: "contact_selectedList_item", type: "normal", showPosition: showPosition && !isOrgItem, subAccountList: subAccountList, getSA: () => {
                            handleChangeSA(item.id, item.email);
                        }, visibleDw: showSubAccounMap[item.id], onDwVisibleClose: () => {
                            setShowSubAccountMap(data => {
                                return Object.assign(Object.assign({}, data), { [item.id]: false });
                            });
                        }, onDwVisibleOpen: () => {
                            setShowSubAccountMap(data => {
                                return Object.assign(Object.assign({}, data), { [item.id]: true });
                            });
                        }, onSubAccountChange: acountObj => {
                            setSelectSubAccountMap(data => {
                                return Object.assign(Object.assign({}, data), { [item.id]: acountObj });
                            });
                        }, dwisLoading: !!loadingMap[item.id], activeSA: (_a = selectSubAccountMap[item.id]) === null || _a === void 0 ? void 0 : _a.email, showAvatar: showAvatar, showCheckbox: showCheckbox, showDelete: _showDelete, item: item, isLeaf: !isOrgItem, onDelete: handleListDelete })));
            }))));
        }
        else {
            return null;
        }
    };
    return (React.createElement("div", { className: styles.selectedListContainer, "data-test-id": "contact_selectedList" },
        React.createElement("div", { className: styles.listTitle },
            getIn18Text('YIXUAN'),
            "\uFF08",
            React.createElement("span", { "data-test-id": "contact_selectedList_count" }, selectMap.size),
            " \uFF09"),
        React.createElement("div", { className: styles.listWrap }, renderList()),
        showFooter && (React.createElement("div", { className: styles.listFooter },
            React.createElement(Button, { "data-test-id": "contact_selectedList_btn_cancel", type: "default", className: styles.listFooterBtn, onClick: () => {
                    handleListCancel();
                } }, getIn18Text('QUXIAO')),
            React.createElement(Button, { "data-test-id": "contact_selectedList_btn_save", disabled: !canSure, type: "primary", className: styles.listFooterBtn, onClick: () => {
                    handleListSure();
                } }, getIn18Text('QUEDING'))))));
};
export default ContactList;
